import { Component, computed, inject, input } from '@angular/core';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { MailRecordsWidgetStore } from './mail-records-widget.store';
import { ServiceSettingsObject } from '@libs/types/src/services/object-type/service/service-settings.object';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';
import {
    dateTimeField,
    numberField,
    serviceField,
    textColumn,
    userChipField,
} from 'packages/client/src/app/modules/shared/components/kit/table/table.fields';
import { UserChipRenderTypeEnum } from 'packages/client/src/app/components/kit/user-chip/user-chip.component.types';
import { router, translate } from 'packages/client/src/app/modules/shared/shared.global-service';
import { folderUri } from 'packages/client/src/app/utils/router.utils';
import { getMailsFrag } from './mail-records-widget.query';
import { FilterBuilder } from '@libs/shared/utils/grid.builder';
import { TableColumn } from '../../../../../shared/components/kit/table/table.types';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { UserChipComponent } from '../../../../../../components/kit/user-chip/user-chip.component';
import { ServiceMailsDirection, ServiceMailsState } from '@libs/types/src/services/enum/service-mails.enums';

@Component({
    selector: 'app-mail-records-widget',
    templateUrl: './mail-records-widget.component.html',
    styleUrl: './mail-records-widget.component.scss',
    providers: [MailRecordsWidgetStore],
    imports: [
        TableComponent,
        PrimeTemplate,
        UserChipComponent,
    ],
})
export class MailRecordsWidgetComponent {

    public items = input<{
        serviceId: string,
        serviceSettings: ServiceSettingsObject[],
        widget: UserWidgetSetting,
    }[]>([]);

    public readonly store = inject(MailRecordsWidgetStore);

    protected columns = computed<TableColumn[]>(() => {
        const showServiceInfo = this.items().length > 1;

        return [
            userChipField(
                'client',
                UserChipRenderTypeEnum.Client,
                {
                    dataKey: 'folder.person',
                    commandCallback: (item: any) => {
                        router.navigate([folderUri(item.folderId || item.id, item.serviceId)]).then();
                    },
                    filterable: false,
                },
            ),
            showServiceInfo ? serviceField('service', 'serviceId') : null,
            numberField('mailNumber'),
            textColumn('info'),
            {
                name: 'type',
                data: (item: any) => {
                    return translate.instant(`enum.serviceMails.type.${item}`);
                },
            },
            textColumn('sender'),
            textColumn('recipient'),
            dateTimeField('sendDate'),
            dateTimeField('receiveDate'),
            {
                name: 'users',
            },
            {
                name: 'state',
                data: (item: any) => {
                    return translate.instant(`enum.serviceMails.state.${item}`);
                },
            },
            textColumn('note'),
        ].filter((it) => it) as TableColumn[];
    });

    protected additionalFilters = computed<any>(() => {
        const filter = new FilterBuilder();

        filter.serviceIds(this.items().map(item => item.serviceId));
        filter.where('directionAndStates', [ServiceMailsDirection.incoming, ServiceMailsState.new, ServiceMailsState.inProgress]);
        filter.orWhere('directionAndStates', [ServiceMailsDirection.outgoing, ServiceMailsState.inProgress]);

        return filter.filter()?.filter || [];
    });

    protected readonly getMailsFrag = getMailsFrag;
}
